/* Aura Viva story product page (av-pdp-* sections). Never touches the product
   form or the cart: buying stays with av-tier.js. */
(function () {
  if (window.__avPdp) return;
  window.__avPdp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function initReveal() {
    var els = $$(document, '.avp-reveal, .avp-rise, [data-avp-stagger], [data-avp-tap]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in', 'is-on'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('in');
        if (el.hasAttribute('data-avp-tap')) el.classList.add('is-on');
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function fmt(n, sep) {
    var s = String(Math.round(n));
    return s.length > 3 ? s.slice(0, -3) + sep + s.slice(-3) : s;
  }
  function initCount() {
    $$(document, '[data-avp-count]').forEach(function (el) {
      var to = parseInt(el.getAttribute('data-avp-count'), 10) || 0;
      var sep = el.getAttribute('data-sep') || '.';
      if (reduce || !('IntersectionObserver' in window)) return;
      el.textContent = '0';
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1400;
        (function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)), sep);
          if (p < 1) requestAnimationFrame(step);
        })(performance.now());
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  function initGallery() {
    $$(document, '[data-avp-buy]').forEach(function (buy) {
      var track = buy.querySelector('[data-avp-track]');
      if (!track) return;
      var slides = $$(track, '.avp-slide');
      var dots = $$(buy, '.avp-dots i');
      var thumbs = $$(buy, '[data-avp-thumb]');
      var idxEl = buy.querySelector('[data-avp-index]');
      var current = 0;
      function set(i) {
        if (i === current) return;
        current = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (idxEl) idxEl.textContent = String(i + 1);
      }
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var w = track.clientWidth || 1;
          set(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
        });
      }, { passive: true });
      function go(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-avp-thumb'), 10) || 0); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, current + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, current - 1)); }
      });
    });
  }

  /* ---------- Video player: loads on tap; poster + spinner until it plays ---------- */
  var modal, frame, vid, closeBtn, lastFocus;
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'av-pdp avp-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.hidden = true;
    modal.innerHTML = '<div class="avp-modal__frame"><video playsinline controls preload="none"></video><span class="avp-spin" aria-hidden="true"></span></div><button type="button" class="avp-modal__close">&times;</button>';
    frame = modal.querySelector('.avp-modal__frame');
    vid = modal.querySelector('video');
    closeBtn = modal.querySelector('.avp-modal__close');
    var closeLabel = document.documentElement.lang === 'en' ? 'Close' : (document.documentElement.lang === 'ca' ? 'Tanca' : 'Cerrar');
    closeBtn.setAttribute('aria-label', closeLabel);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); }
      if (e.key === 'Tab') {
        var f = [vid, closeBtn];
        var i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
      }
    });
    vid.addEventListener('playing', function () { frame.classList.remove('is-loading'); });
    vid.addEventListener('waiting', function () { frame.classList.add('is-loading'); });
    document.body.appendChild(modal);
  }
  function openModal(src, poster, label, trigger) {
    if (!src) return;
    if (!modal) buildModal();
    lastFocus = trigger || document.activeElement;
    frame.style.backgroundImage = poster ? 'url("' + poster + '")' : '';
    if (poster) vid.setAttribute('poster', poster); else vid.removeAttribute('poster');
    vid.setAttribute('aria-label', label || '');
    vid.muted = false;
    vid.src = src;
    frame.classList.add('is-loading');
    modal.hidden = false;
    document.documentElement.classList.add('avp-modal-open');
    var p = vid.play();
    if (p && p.catch) p.catch(function () { frame.classList.remove('is-loading'); });
    closeBtn.focus();
  }
  function closeModal() {
    if (!modal || modal.hidden) return;
    vid.pause();
    vid.removeAttribute('src');
    vid.load();
    modal.hidden = true;
    frame.classList.remove('is-loading');
    document.documentElement.classList.remove('avp-modal-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initVideoButtons() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-avp-video]');
      if (!b) return;
      e.preventDefault();
      openModal(b.getAttribute('data-avp-video'), b.getAttribute('data-avp-poster'), b.getAttribute('aria-label') || b.textContent.trim(), b);
    });
  }

  /* ---------- Connect: tabs + inline guide video ---------- */
  function playInline(frameEl) {
    var v = frameEl.querySelector('video');
    if (!v) return;
    if (!v.src && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
    v.controls = true;
    frameEl.classList.add('is-loading');
    v.addEventListener('playing', function () { frameEl.classList.remove('is-loading'); frameEl.classList.add('is-playing'); }, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () { frameEl.classList.remove('is-loading'); });
  }
  function initTabs() {
    $$(document, '[data-avp-tabs]').forEach(function (root) {
      var tabs = $$(root, '[role="tab"]');
      var panels = $$(root, '[role="tabpanel"]');
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p) {
          var on = p.id === tab.getAttribute('aria-controls');
          p.hidden = !on;
          if (!on) $$(p, 'video').forEach(function (v) { v.pause(); });
          if (on) $$(p, '.avp-reveal').forEach(function (el) { el.classList.add('in'); });
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      if (/android/i.test(navigator.userAgent)) {
        var a = root.querySelector('[data-tab="android"]');
        if (a) select(a);
      }
      $$(root, '[data-avp-inline-play]').forEach(function (b) {
        b.addEventListener('click', function () { playInline(b.closest('.avp-vframe')); });
      });
    });
  }

  function initAmbient() {
    var vids = $$(document, 'video[data-avp-autoplay]');
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src) v.src = v.getAttribute('data-src');
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- Delivery estimate: Mon-Fri minus holidays, Madrid time; after the
     cutoff on a working day the count starts tomorrow (Fri 15:00 + 2 = Tue). */
  var NAMES = {
    es: { d: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], m: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'] },
    ca: { d: ['dg.', 'dl.', 'dt.', 'dc.', 'dj.', 'dv.', 'ds.'], m: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'] },
    en: { d: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], m: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] }
  };
  function madridNow() {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour };
    } catch (e) {
      var n = new Date();
      return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() };
    }
  }
  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function addBusinessDays(start, n, holidays) {
    var d = new Date(start.getTime());
    var c = 0;
    while (c < n) {
      d.setUTCDate(d.getUTCDate() + 1);
      var wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6 && holidays.indexOf(iso(d)) === -1) c++;
    }
    return d;
  }
  function initEta() {
    var el = document.querySelector('[data-avp-eta]');
    if (!el) return;
    var lang = NAMES[el.getAttribute('data-lang')] ? el.getAttribute('data-lang') : 'es';
    var N = NAMES[lang];
    var min = parseInt(el.getAttribute('data-min'), 10) || 2;
    var max = Math.max(min, parseInt(el.getAttribute('data-max'), 10) || min);
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoff)) cutoff = 14;
    var holidays = String(el.getAttribute('data-holidays') || '').split(/[\s,]+/).filter(Boolean);
    var now = madridNow();
    var base = new Date(Date.UTC(now.y, now.m - 1, now.d));
    var wd0 = base.getUTCDay();
    var workingToday = wd0 !== 0 && wd0 !== 6 && holidays.indexOf(iso(base)) === -1;
    // The cutoff only matters on a working day; a weekend order waits anyway.
    if (workingToday && now.h >= cutoff) base.setUTCDate(base.getUTCDate() + 1);
    var a = addBusinessDays(base, min, holidays);
    var b = addBusinessDays(base, max, holidays);
    function shortD(dt) { return N.d[dt.getUTCDay()] + ' ' + dt.getUTCDate() + ' ' + N.m[dt.getUTCMonth()]; }
    function dayMonth(dt) { return dt.getUTCDate() + ' ' + N.m[dt.getUTCMonth()]; }
    var sameMonth = a.getUTCMonth() === b.getUTCMonth();
    var aTxt = sameMonth ? N.d[a.getUTCDay()] + ' ' + a.getUTCDate() : shortD(a);
    var html = min === max
      ? el.getAttribute('data-pattern-one').replace('{a}', shortD(a))
      : el.getAttribute('data-pattern').replace('{a}', aTxt).replace('{b}', shortD(b));
    var txt = el.querySelector('[data-avp-eta-text]');
    if (txt) txt.innerHTML = html;
    el.classList.add('is-ready');
    var shortTxt = (el.getAttribute('data-pattern-short') || '').replace('{a}', sameMonth ? String(a.getUTCDate()) : dayMonth(a)).replace('{b}', dayMonth(b));
    $$(document, '[data-avp-eta-short]').forEach(function (s) { s.textContent = shortTxt ? ' · ' + shortTxt : ''; });
  }

  /* ---------- Sticky bar: shows once the real button scrolls up out of view and
     clicks that real button, so the cart flow and payload are the same. */
  function initSticky() {
    var bar = document.querySelector('[data-avp-sticky]');
    if (!bar) return;
    var atc = document.getElementById(bar.getAttribute('data-target'));
    if (!atc) { bar.remove(); return; }
    document.body.appendChild(bar);
    var btn = bar.querySelector('[data-avp-sticky-add]');
    btn.addEventListener('click', function () { atc.click(); });
    var above = false, videoPlaying = false;
    function syncDisabled() { btn.disabled = !!atc.disabled; }
    function apply() {
      var show = above && !videoPlaying && !(document.documentElement.classList.contains('avp-modal-open'));
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('av-sticky-visible', show);
      syncDisabled();
    }
    new MutationObserver(syncDisabled).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    function counts(v) { return v && v.tagName === 'VIDEO' && !v.hasAttribute('data-av-ambient'); }
    function anyPlaying() {
      return $$(document, 'video:not([data-av-ambient])').some(function (v) { return !v.paused && !v.ended; });
    }
    document.addEventListener('play', function (e) { if (counts(e.target)) { videoPlaying = true; apply(); } }, true);
    ['pause', 'ended', 'emptied'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (counts(e.target)) { videoPlaying = anyPlaying(); apply(); } }, true);
    });
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      above = !e.isIntersecting && e.boundingClientRect.top < 0;
      apply();
    }, { threshold: 0 }).observe(atc);
  }

  function initWatch() {
    var tpl = document.querySelector('template[data-avp-watch-tpl]');
    var slot = document.querySelector('[data-avp-watch-slot]');
    if (tpl && slot) slot.appendChild(tpl.content.cloneNode(true));
  }

  function init() {
    initWatch();
    initReveal();
    initCount();
    initGallery();
    initVideoButtons();
    initTabs();
    initAmbient();
    initEta();
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
